import type { VFC } from 'react'

import Price from 'views/components/atoms/Price'

type DeliveryCostType = {
  code: string
  deliveryTime: {
    earliestDays: number
    latestDays: number
  }
  label: string
  totalShippingPrice: number
}

type Props = {
  deliveryCosts: DeliveryCostType[]
}

const renderTableRow = (item: DeliveryCostType) => (
  <tr key={`delivery-cost-${item.label}`}>
    <td className="l-flex l-flex--distribute-space a-box--medium">
      <span className="u-font-weight--bold u-text-transform--capitalize">
        {item.label}
      </span>
      <span className="u-font-weight--normal u-text-transform--capitalize">
        <Price amount={item.totalShippingPrice} decimalPlaces={2} symbolRight />
      </span>
    </td>
  </tr>
)

const renderTable = (deliveryCosts: DeliveryCostType[]) => (
  <table className="a-table">
    <tbody>
      {deliveryCosts.map((item: DeliveryCostType) => renderTableRow(item))}
    </tbody>
  </table>
)

const DeliveryCostsMp: VFC<{
  deliveryCosts: DeliveryCostType[]
}> = ({ deliveryCosts }: Props) => renderTable(deliveryCosts)

export default DeliveryCostsMp
